import { render, staticRenderFns } from "./RatioBox.vue?vue&type=template&id=42e5dfd8&scoped=true"
import script from "./RatioBox.vue?vue&type=script&lang=js"
export * from "./RatioBox.vue?vue&type=script&lang=js"
import style0 from "./RatioBox.vue?vue&type=style&index=0&id=42e5dfd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e5dfd8",
  null
  
)

export default component.exports